import React from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { DateTime } from "components/common/Date";
import { useClientOverview } from "./ClientOverviewContext";
import { getClientDisplayName } from "features/Clients/utils/clientDisplayName";
import {
  ClientType,
  ClientTypeLabelMap,
  type ClientTypeValue,
} from "features/Clients/constants/client-organization.constants";

const OverviewTab = () => {
  const { client } = useClientOverview();

  const typeVal = client?.type as ClientTypeValue | undefined;
  const typeLabel =
    typeVal && typeVal in ClientTypeLabelMap
      ? ClientTypeLabelMap[typeVal as ClientType]
      : (client?.type ?? "—");

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <div className="text-muted">
                <h6 className="mb-3 text-uppercase">Organization</h6>
                <Row>
                  <Col lg={8}>
                    <div className="table-responsive">
                      <Table className="table-borderless mb-0">
                        <tbody>
                          <tr>
                            <th
                              className="ps-0"
                              scope="row"
                              style={{ width: "200px" }}
                            >
                              Name
                            </th>
                            <td className="text-muted">
                              {getClientDisplayName(client ?? undefined)}
                            </td>
                          </tr>

                          <tr>
                            <th className="ps-0" scope="row">
                              Company / trade name
                            </th>
                            <td className="text-muted">
                              {client?.company?.trim() || "—"}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-0" scope="row">
                              Type
                            </th>
                            <td className="text-muted">{typeLabel}</td>
                          </tr>
                          <tr>
                            <th className="ps-0" scope="row">
                              Sector
                            </th>
                            <td className="text-muted">
                              {client?.sector?.name?.trim() || "—"}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-0" scope="row">
                              Website
                            </th>
                            <td className="text-muted">
                              {client?.website?.trim() || "—"}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-0" scope="row">
                              GST
                            </th>
                            <td className="text-muted">
                              {client?.gstNumber?.trim() || "—"}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-0" scope="row">
                              PAN
                            </th>
                            <td className="text-muted">
                              {client?.panNumber?.trim() || "—"}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-0" scope="row">
                              Billing address
                            </th>
                            <td
                              className="text-muted"
                              style={{ whiteSpace: "pre-wrap" }}
                            >
                              {client?.billingAddress?.trim() || "—"}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-0" scope="row">
                              Shipping address
                            </th>
                            <td
                              className="text-muted"
                              style={{ whiteSpace: "pre-wrap" }}
                            >
                              {client?.shippingAddress?.trim() || "—"}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>

                <h6 className="mb-3 mt-4 text-uppercase">Account</h6>
                <Row>
                  <Col lg={8}>
                    <div className="table-responsive">
                      <Table className="table-borderless mb-0">
                        <tbody>
                          <tr>
                            <th className="ps-0" scope="row">
                              E-mail
                            </th>
                            <td className="text-muted">
                              {client?.email || "—"}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-0" scope="row">
                              Phone
                            </th>
                            <td className="text-muted">
                              {client?.phone || "—"}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-0" scope="row">
                              Address
                            </th>
                            <td className="text-muted">
                              {[client?.address, client?.city, client?.state]
                                .filter(Boolean)
                                .join(", ") || "—"}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>

                <div className="pt-3 border-top border-top-dashed mt-4">
                  <Row className="gy-3">
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">Created</p>
                        <h5 className="fs-14 mb-0">
                          {client?.created_at ? (
                            <DateTime date={client.created_at} />
                          ) : (
                            "—"
                          )}
                        </h5>
                      </div>
                    </Col>
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          Last updated
                        </p>
                        <h5 className="fs-14 mb-0">
                          {client?.updated_at ? (
                            <DateTime date={client.updated_at} />
                          ) : (
                            "—"
                          )}
                        </h5>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default OverviewTab;
